import _ from 'lodash';
import { seasonalHelpers } from "projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers";
import { createRefPath_client, createRefPath_event } from "../../appData/appRefPaths";

const _allowSubUpdate = true

/**
 * 
 * @param {object} pathViews 
 * @param {object} pks 
 * @param {string} documentFieldName 
 * @param {object} data 
 * @param {string} collectionName ** with _
 * @param {function} callback 
 * @description Updates the `_seasonalCollectionName` or the collectionName prefixed with an `_`
 */
export const fsUpdate_subCollection = async (database_fns, pathViews, pks, collectionName, data, callback) => {

  const { key, _itemKey } = data
  const key_data = key || _itemKey

  const subCollectionName = '_' + collectionName

  // fijiVHGeULUXvA9yhXdm
  //qx8THAg994tpDUlNVDiR

  let _collectionItem;

  if (pks && !_.isEmpty(pks)) {
    _collectionItem = await seasonalHelpers.getSports_collectionItem(database_fns, pathViews, pks, subCollectionName, true)
  } else {
    if (pathViews.events) {
      const _refPath = createRefPath_event(pathViews, [subCollectionName, collectionName])
      _collectionItem = await database_fns.get_doc({ refPath: _refPath })
    } else {
      const _refPath = createRefPath_client(pathViews, [subCollectionName, collectionName])
      _collectionItem = await database_fns.get_doc({ refPath: _refPath })
    }
  }

  if (_collectionItem && !_.isEmpty(_collectionItem)) {

    const { _itemKey: _item_key } = _collectionItem


    let _refPath;

    if (pathViews.events) {
      _refPath = createRefPath_event(pathViews, [subCollectionName, _item_key])
    } else {
      _refPath = createRefPath_client(pathViews, [subCollectionName, _item_key])
    }

    const refKey = key_data || database_fns.get_docKey()

    const dataToUpdate = { [collectionName + '.' + refKey]: data }
    console.log('_refPath', _refPath, dataToUpdate)

    _allowSubUpdate && database_fns.update_doc(_refPath, dataToUpdate, callback)

  } else {
    const _refPath = createRefPath_client(pathViews, [subCollectionName])

    console.log('_refPath', _refPath)

    // if (_refPath) {
    //   const dataToAdd = {
    //     parentKeys: pks,
    //     [collectionName]: data
    //   }

    //   _allowSubUpdate && database_fns.add_doc(_refPath, dataToAdd, callback)
    // }

  }
} 